/**
 * Canicule : pulse chaud/froid + scan de fraîcheur au clic sur le wordmark header.
 * Cible DOM : .header-logo .canicule-wordmark
 * Respecte prefers-reduced-motion · ne bloque pas la navigation home.
 */
(function () {
  'use strict';

  var SCAN_MS = 900;
  var SCAN_REDUCED_MS = 280;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function triggerScan(wordmark) {
    if (wordmark.classList.contains('canicule-brand--scanning')) return;

    wordmark.classList.add('canicule-brand--scanning');
    if (reducedMotion) {
      wordmark.classList.add('canicule-brand--scan-reduced');
    }

    window.setTimeout(function () {
      wordmark.classList.remove('canicule-brand--scanning', 'canicule-brand--scan-reduced');
    }, reducedMotion ? SCAN_REDUCED_MS : SCAN_MS);
  }

  function init() {
    var headerLink = document.querySelector('.header-logo');
    if (!headerLink) return;

    var wordmark = headerLink.querySelector('.canicule-wordmark');
    if (!wordmark) return;

    wordmark.classList.add('canicule-brand-pulse');

    if (!headerLink.getAttribute('aria-label')) {
      headerLink.setAttribute('aria-label', 'Canicule, accueil');
    }

    headerLink.addEventListener(
      'click',
      function () {
        triggerScan(wordmark);
      },
      { passive: true }
    );

    headerLink.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        triggerScan(wordmark);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
